import { render, staticRenderFns } from "./PazarCloud.vue?vue&type=template&id=390aa69a"
import script from "./PazarCloud.vue?vue&type=script&lang=js"
export * from "./PazarCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports